import { isEnumLikeSchema } from '@takeshape/schema';
export function shouldUseInputSuffix(shape) {
    return !isEnumLikeSchema(shape.schema) && !shape.type;
}
export function addInputSuffix(name) {
    return `${name.replace('Input', '')}Input`;
}
